<template>
  <div
    v-if="size !== 'size-mini'"
    :class="{[size]:size}"
    class="artwork-meta"
  >
    <Artwork :store="store" />
    <MetaInfo :store="store" />
  </div>
</template>

<script>
import Artwork from './Artwork'
import MetaInfo from './MetaInfo'

export default {
  components: {
    Artwork,
    MetaInfo
  },
  props: {
    store: {
      type: Object,
      default: function () {}
    }
  },
  computed: {
    size () { return this.store.state.size }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints.scss';

.artwork-meta {
  display: flex;
  z-index: 1;
  align-items: center;
  padding: 0;
  box-sizing: border-box;

  @media (min-width: $bp_xs) {
    height: 120px;
    padding: 8px 0;
  }
  @media (min-width: $bp_sm) {
    padding: 0;
    height: auto;
  }

  .artwork {
    display: none;
    width: 100%;

    @media (min-width: $bp_xs) {
      display: block;
      height: 92px;
      margin-right: 13px;
      max-width: 92px;
    }
    @media (min-width: $bp_sm) {
      height: 164px;
      max-width: 164px;
      width: 164px;
    }
  }
  .meta-info {
    display: block;

    @media (min-width: $bp_sm) {
      display: none;
    }
  }
}
</style>
